import React from "react";
import { motion } from "framer-motion";

const featureItems = [
  {
    title: "Dedicated RPC Nodes",
    description:
      "Launch your own high-performance RPC nodes in minutes. We handle provisioning, configuration, and optimization so you can focus on building — not infrastructure.",
    iconClass: "fa-solid fa-server",
  },
  {
    title: "Real-Time Monitoring",
    description:
      "Visualize uptime, latency, response time, and network health through an intuitive dashboard. Stay ahead of issues with transparent performance metrics.",
    iconClass: "fa-solid fa-chart-line",
  },
  {
    title: "Multi-Chain Support",
    description:
      "We support all major blockchains, allowing you to scale across ecosystems without switching providers. One subscription. Multiple networks. Total flexibility.",
    iconClass: "fa-solid fa-network-wired",
  },
  {
    title: "Scalable Infrastructure",
    description:
      "Built for production-grade apps. Enterprise-level reliability, secure endpoints, and scalable resources that grow with your project.",
    iconClass: "fa-solid fa-layer-group",
  },
];

const ServicesSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="flex min-h-screen w-full flex-col items-start justify-center gap-10 px-6"
    >
      <div className="flex flex-col items-start text-start">
        <h2 className="font-title mt-4 max-w-[720px] text-[36px] font-semibold leading-[1.08] text-white sm:text-[44px] md:text-6xl">
          Everything you need to deploy your app
        </h2>
        <p className="font-secondary mt-5 max-w-[670px] text-[17px] leading-relaxed text-white sm:text-[18px]">
          Reliable infrastructure, real-time performance insights, and
          multi-chain support — all in one powerful subscription.
        </p>
      </div>

      <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 sm:items-stretch lg:mt-16 lg:grid-cols-4">
        {featureItems.map((item, index) => (
          <motion.article
            key={item.title}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{
              duration: 0.45,
              ease: "easeOut",
              delay: index * 0.05,
            }}
            className="flex h-full min-h-[280px] w-full max-w-[420px] flex-col rounded-none border border-zinc-700/30 bg-[#131313] p-8 sm:max-w-none"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-none bg-[#353535]">
              <i
                className={`${item.iconClass} text-[22px] leading-none text-primary`}
                aria-hidden="true"
              />
            </div>
            <h3 className="font-title mt-5 text-xl font-semibold leading-snug text-white sm:text-xl">
              {item.title}
            </h3>
            <p className="font-secondary mt-3 flex-1 text-lg leading-relaxed text-white/55 sm:text-[15px]">
              {item.description}
            </p>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
};

export default ServicesSection;
